import { openBlock as t, createElementBlock as o, createElementVNode as e } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, c = /* @__PURE__ */ e("path", { d: "M8.022 3.998c1.374 0 2.287.759 2.287 1.87 0 .725-.352 1.22-1.034 1.626-.637.374-.813.605-.813 1.067v.253H7.187V8.55c-.077-.77.186-1.199.857-1.594.616-.374.803-.605.803-1.045 0-.44-.363-.758-.913-.758s-.912.34-.945.868H5.69c.022-1.198.858-2.023 2.331-2.023Zm-.187 6.157a.93.93 0 0 1 .924.923.929.929 0 0 1-.924.924.929.929 0 0 1-.923-.924.93.93 0 0 1 .923-.923Z" }, null, -1), l = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M15.16 10.966A7.751 7.751 0 0 0 5.034.84 7.75 7.75 0 1 0 15.16 10.966Zm-9.552-8.74a6.25 6.25 0 1 1 4.784 11.548A6.25 6.25 0 0 1 5.608 2.226Z",
  "clip-rule": "evenodd"
}, null, -1), d = [
  c,
  l
];
function r(s, _) {
  return t(), o("svg", n, [...d]);
}
const h = { render: r };
export {
  h as default,
  r as render
};
